import { z } from 'zod';
/**
 * Canonical `PublicSettings` contract for `GET /api/v1/public/settings`
 * (ROADMAP #32). Previously duplicated in three places (bootstrap.ts inline,
 * useKiosk.ts, useAdminApi.ts) and grown additively across OU-1d/1e.
 *
 * Convention (CLAUDE.md §16, ROADMAP #32): the public payload carries ONLY the
 * school identity + boolean tab-/feature-gating flags. Numeric or role-specific
 * values (e.g. `assessmentScaleMax`) belong in the authenticated
 * `/dashboard/settings` payload, never here. `.strict()` enforces that
 * structurally: adding any field — boolean or otherwise — requires an explicit
 * edit to this schema, so a numeric value can never silently ride along.
 */
export const PublicSettingsSchema = z
    .object({
    schoolName: z.string(),
    iservSsoEnabled: z.boolean(),
    iservConfigured: z.boolean(),
    // OU-1d: student-facing flags (login landing + SelfReport tab gating).
    selfReportEnabled: z.boolean(),
    studentLoginEnabled: z.boolean(),
    // OU-1e: assessment flags (teacher-dashboard tab gating + RatingInput).
    assessmentEnabled: z.boolean(),
    assessmentRatingEnabled: z.boolean(),
    assessmentRatingRequired: z.boolean(),
    // OU-2a: Sozialpass — gated den Dashboard-Nav-Punkt und den SuS-Tab.
    sozialpassEnabled: z.boolean(),
})
    .strict();
//# sourceMappingURL=public-settings.js.map